var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.2 0H0v3.2h3.2zm0 4.267H0v3.2h3.2zM0 8.533h3.2v3.2H0zM3.2 12.8H0V16h3.2zM4.267 0h3.2v3.2h-3.2zm3.2 4.267h-3.2v3.2h3.2zm-3.2 4.266h3.2v3.2h-3.2zm3.2 4.267h-3.2V16h3.2zM8.533 0h3.2v3.2h-3.2zm3.2 4.267h-3.2v3.2h3.2zm-3.2 4.266h3.2v3.2h-3.2zm3.2 4.267h-3.2V16h3.2zM12.8 0H16v3.2h-3.2zM16 4.267h-3.2v3.2H16zm-3.2 4.266H16v3.2h-3.2zM16 12.8h-3.2V16H16z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
export default SvgSmallLayout;